module.exports = __webpack_public_path__ + "static/img/POST_SCARICA-APP.62cc024.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/marketing/POST_SCARICA-APP.png
// module id = +hPT
// module chunks = 1